import { HttpBackend, HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiEndPoint } from "../../app.component";
import { Brand, Item, TransferItem } from "../models/store";

@Injectable({
  providedIn: "root",
})
export class StoreService {
  base: string = ApiEndPoint + "store/";
  printHttp: HttpClient;
  constructor(private http: HttpClient, handler: HttpBackend) {
    this.printHttp = new HttpClient(handler);
  }

  listCategories() {
    return this.http.get(`${this.base}category/list/`);
  }

  listItemFromColrSize(data) {
    return this.http.post(
      `${this.base}item/getBarcodeForSameItemInBrand/`,
      data
    );
  }

  listItemsToMove() {
    return this.http.get(`${ApiEndPoint}sales/webOrder/itemsToTransfer/`);
  }

  soldItemsById(id) {
    return this.http.get(`${ApiEndPoint}sales/itemsSold/listBy/${id}`);
  }

  itemsTransfeardById(id) {
    return this.http.get(`${this.base}transferItem/listby/` + id + "/");
  }

  sentToWebRequest(id: number) {
    return this.http.get(
      `${ApiEndPoint}sales/webOrder/sentToWebRequest/${id}/`
    );
  }

  createCategory(data) {
    return this.http.post(`${this.base}category/create/`, data);
  }
  updateCategory(data) {
    return this.http.put(`${this.base}category/edit/${data.id}/`, data);
  }
  deleteCategory(id: number) {
    return this.http.delete(`${this.base}category/edit/${id}/`);
  }
  listPrintByBrandId(brandId: number) {
    return this.http.get(`${this.base}print/list/${brandId}/`);
  }
  createPrint(data) {
    return this.http.post(`${this.base}print/create/`, data);
  }
  updatePrint(data) {
    return this.http.put(`${this.base}print/edit/${data.id}/`, data);
  }
  deletePrint(printId: number) {
    return this.http.delete(`${this.base}print/edit/${printId}/`);
  }

  listBrands() {
    return this.http.get(`${this.base}brand/list/`);
  }
  listBrandsBycompanyId(companyId: number) {
    return this.http.get(`${this.base}brand/listby/${companyId}/`);
  }
  listBrandsPagination(number: number): Observable<Brand[]> {
    return this.http.get<Brand[]>(
      `${this.base}brand/pagation/?page=${number + 1}`
    );
  }
  searchBrandsByText(searchTerm: string) {
    return this.http.get(`${this.base}brand/filterByText/${searchTerm}/`);
  }
  createBrand(data) {
    return this.http.post(`${this.base}brand/create/`, data);
  }
  updateBrand(data) {
    return this.http.put(`${this.base}brand/edit/${data.id}/`, data);
  }
  deleteBrand(brandId: number) {
    return this.http.delete(`${this.base}brand/edit/${brandId}/`);
  }
  listPurchaseBatchByBrandId(brandId: number) {
    return this.http.get(`${this.base}purchaseBatch/listBy/${brandId}/`);
  }
  listPurchaseBatchItems(id: number) {
    return this.http.get(`${this.base}item/listBy/${id}/`);
  }
  listPurchaseBatch() {
    return this.http.get(`${this.base}purchaseBatch/list/`);
  }
  createPurchaseBatch(data) {
    return this.http.post(`${this.base}purchaseBatch/create/`, data);
  }
  updatePurchaseBatch(data) {
    return this.http.put(`${this.base}purchaseBatch/edit/${data.id}/`, data);
  }
  deletePurchaseBatch(id: number) {
    return this.http.delete(`${this.base}purchaseBatch/edit/${id}/`);
  }

  listItems(number: number, myStore: boolean = false): Observable<Item[]> {
    if (myStore)
      return this.http.get<Item[]>(
        `${this.base}item/listInMyStore/?page=${number + 1}`
      );
    return this.http.get<Item[]>(`${this.base}item/list/?page=${number + 1}`);
  }
  listItemByBarcode(barcode: string) {
    return this.http.get(`${this.base}item/listForSale/${barcode}/`);
  }

  listFilteredItems(data, myStore: boolean = false) {
    if (myStore)
      return this.http.post(`${this.base}item/filterInMyStore/`, data);

    return this.http.post(`${this.base}item/filter/`, data);
  }

  createItem(data) {
    return this.http.post(`${this.base}item/create/`, data);
  }

  updateItem(data) {
    return this.http.put(`${this.base}item/edit/${data.id}/`, data);
  }

  updateItemInventory(data) {
    return this.http.put(`${this.base}item/storeEdit/${data.id}/`, data);
  }
  deleteItem(id: number) {
    return this.http.delete(`${this.base}item/edit/${id}/`);
  }

  listCompanies() {
    return this.http.get(`${this.base}company/list/`);
  }
  createCompany(data) {
    return this.http.post(`${this.base}company/create/`, data);
  }
  updateCompany(data) {
    return this.http.put(`${this.base}company/edit/${data.id}/`, data);
  }
  deleteCompany(companyId: number) {
    return this.http.delete(`${this.base}company/edit/${companyId}/`);
  }

  printBarcodeOnDesktop(barcode: string, exPrice: string) {
    return this.printHttp.get(
      `http://127.0.0.1:12000/api/barcode/${barcode}/${exPrice}/`
    );
  }

  myStoreItemListByBarcod(barcode) {
    return this.http.get(`${this.base}item/storelist/barcode/${barcode}/`);
  }
  printBranchLoggedIn(branchId) {
    return this.printHttp.get(`http://127.0.0.1:12000/api/branch/${branchId}/`);
  }
  printBarcodeOnMobile(data) {
    return this.http.post(`${this.base}print/create/`, data);
  }
  printFatoraOnDesktop(barcode: string, exPrice: string) {
    return this.printHttp.get(
      `http://127.0.0.1:12000/api/fatora/${barcode}/${exPrice}/`
    );
  }

  listTransferItem(): Observable<TransferItem[]> {
    return this.http.get<TransferItem[]>(`${this.base}transferItem/list/`);
  }

  createTransferItem(data) {
    return this.http.post(`${this.base}transferItem/create/`, data);
  }

  updateTransferItem(data) {
    return this.http.put(`${this.base}transferItem/edit/${data.id}/`, data);
  }
  deleteTransferItem(id: number) {
    return this.http.delete(`${this.base}transferItem/edit/${id}/`);
  }
  transferItemDone(transferId: number) {
    return this.http.get(`${this.base}transferItem/done/${transferId}/`);
  }
  listStoreValue() {
    return this.http.get(`${this.base}storeValue/`);
  }
  listBrandsByPeriod(
    from: string,
    to: string,
    companyId: number,
    branchId: number
  ) {
    return this.http.get(
      `${this.base}brand/listperiod/${from}/${to}/${companyId}/${branchId}/`
    );
  }
}
